/**
 * SOLID Review
 * S — Strong. One concern: players on the server, as the `ClientPlayerServer` port speaks them.
 * O — Good. A new player op is one method over the same adapter.
 * L — Strong. Implements the port interface exactly.
 * I — Strong. One op.
 * D — Strong. The Application's adapter interface and the shared result mapping.
 */
import type { IContextRequest } from '../../domain/ports/schemas/ContextRequest';
import type { IPayloadGuest } from '../../domain/ports/schemas/SessionMoves';
import type { IPortClientPlayerServer } from '../../application/ports/contracts';
import type { IAdapterApolloSession } from '../../application/ports/IAdapterApolloSession';
import { fromAdapter } from './wireResult';

/**
 * THE PLAYER GATEWAY (frontend strict-ports plan, FE2, 2026-10-03), over `ApolloSessionAdapter`: the
 * guest IdentityModal creates. The answer is the three fields a seat reads; the contract parses them.
 */
export class ClientPlayerServerAdapter implements IPortClientPlayerServer {
  constructor(private readonly sessions: IAdapterApolloSession) {}

  async createPlayer(_ctx: IContextRequest, request: IPayloadGuest) {
    return fromAdapter(await this.sessions.createPlayer(request.displayName), (player) => ({
      id: player.id,
      displayName: player.displayName,
      matchCredits: player.matchCredits,
    }));
  }
}
